import React from "react";
import styled from "styled-components";
import { shade } from "polished";
import { Text as RebassText } from "rebass";

const Text = styled(RebassText)`
  > strong,
  > b {
    font-weight: ${props => props.theme.fontWeights.bold};
  }
  > a {
    color: ${props => props.theme.colors.violet};
    text-decoration: none;
    box-shadow: inset 0 -1px 0 ${props => props.theme.colors.violet};
    transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),
      box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);
    will-change: color, box-shadow;
    &:hover {
      color: #fff;
      box-shadow: inset 0 -1.5em 0 ${props => props.theme.colors.violet};
    }
    &:active {
      color: #fff;
      box-shadow: inset 0 -1.5em 0 ${props => props.theme.colors.violet && shade(0.75, props.theme.colors.violet)};
    }
  }
`;

Text.defaultProps = {
  is: "p",
  m: 0,
  color: "text",
  fontSize: 2,
  lineHeight: 3
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/Text.js